let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jtwfh")).then(() => parcelRequire('6ZUmE'));